import React, { useRef, useState, useEffect } from "react"
import { withTranslation } from "react-i18next"
import { ShimmerThumbnail } from "react-shimmer-effects"
import { Grid, Image, Input, Segment } from "semantic-ui-react"
import MembershipDownload from "../../assets/images/membership-download.svg"
import MembershipInfoLogo from "../../assets/images/membership-info.svg"
import MembershipShops from "../../assets/images/membership_shops.svg"
import Button from "../../elements/Button"
import FleetCard from "./FleetCard"
import { FLEET_ADVISE, PAGE_ORIANTATION, PRINT, TEXT_CSS } from "../../constants/membershipCard"
import { getSubdomain } from "../../components/shared/StylesheetInjector"
import { isFuelman } from "../../helpers/affiliationHelpers"
import ReactSVG from "react-svg"
import { logClickEvent } from "../../helpers/googleAnalyticsHelpers"
import { DISCOUNT_TIRE, VIN } from "../../constants/application"
import { debounce } from "lodash"
import * as arrayHelpers from "../../helpers/arrayHelpers"
// import DiscountTireLogo from "../../assets/images/discountTire_logo.svg"
import { connect } from "react-redux"
import { NOTIFICATION_TYPE } from "../../constants/notification"
import CustomNotification from "../../components/shared/CustomNotification"

const MembershipCard = ({
  membershipName,
  driverName,
  membershipLogo,
  membershipAccount,
  membershipBarcode,
  helpCenterName,
  worldwideStores,
  phone,
  membershipIntegrate,
  sectionSubnote,
  fleetVehicles,
  selectedVehicle,
  getSelectedVehicle,
  isLoading,
  t,
  isFMCMode,
  isFleetMode,
  dispatch,
  fmcVehicles
}) => {
  const cardRef = useRef(null)
  const [isPdfLoading, setIsPdfLoading] = useState(false)
  const [showFmcCard, setshowFmcCard] = useState(false)
  const isVehicleAvailable = isFMCMode ? false : fleetVehicles && fleetVehicles.length > 0

  const downloadCard = () => {
    let css = PAGE_ORIANTATION,
      head = document.head || document.getElementsByTagName("head")[0],
      style = document.createElement("style")

    style.type = TEXT_CSS
    style.media = PRINT

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    logClickEvent(window.location.pathname)
    window.print()
  }

  let sub = getSubdomain()

  let size = 90
  if (isFuelman()) size = 100
  const extraStyles = { backgroundColor: "#e3eae6", borderRadius: "0 0 0 6px", height: "9vh" }

  return (
    <div className="membership_parent">
      <div className="membership_container">
        <div className="membership_cars">
          <p className="membership_box_title">{t("membershipCard")}</p>
          {isVehicleAvailable && (
            <p className="membership_box_subheader">
              {!isFMCMode ? (
                <>
                  <span>{membershipName}</span> {sectionSubnote}{" "}
                </>
              ) : (
                <></>
              )}
            </p>
          )}
          {isLoading ? (
            <Grid.Column>
              <ShimmerThumbnail className="shimmer_squere" rounded height={90} />
            </Grid.Column>
          ) : isVehicleAvailable || isFMCMode ? (
            <>
              <div className="membership_info">
                <Image src={MembershipInfoLogo} />
                <p className="membership_help">
                  {t("identifyWithCard")} {phone}.
                </p>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
        <div
          className={`${
            !(isVehicleAvailable || (isFMCMode && showFmcCard)) && !isLoading ? "custom_bg" : ""
          } membership_box`}
        >
          {isLoading ? (
            <Grid.Column>
              <ShimmerThumbnail className="card_shimmer_squere" rounded height={550} />
            </Grid.Column>
          ) : isVehicleAvailable || showFmcCard ? (
            <FleetCard
              cardRef={cardRef}
              membershipName={membershipName}
              driverName={driverName}
              membershipLogo={membershipLogo}
              membershipAccount={membershipAccount}
              membershipBarcode={membershipBarcode}
              membershipIntegrate={membershipIntegrate}
              worldwideStores={worldwideStores}
              MembershipShops={MembershipShops}
              phone={phone}
              helpCenterName={helpCenterName}
            />
          ) : !isVehicleAvailable || (isFMCMode && !showFmcCard) ? (
            <>
              <div className="fleet_no_vehicle_box">
                {sub === FLEET_ADVISE ? (
                  <Image src={membershipLogo} className="membership_logo" />
                ) : (
                  <ReactSVG
                    src={sub === DISCOUNT_TIRE ? "DiscountTireLogo" : `/images/${sub}_logo.svg`}
                    svgStyle={{
                      ...extraStyles,
                      width: size
                    }}
                  />
                )}
              </div>
              <p className="no_membership_info">{t("noMembershipInfo")}</p>
            </>
          ) : (
            <></>
          )}
          {isLoading ? (
            <Grid.Column>
              <ShimmerThumbnail className="shimmer_squere" rounded height={40} />
            </Grid.Column>
          ) : (
            (isVehicleAvailable || (isFMCMode && showFmcCard)) && (
              <Button
                className="membership_download"
                onClick={downloadCard}
                loading={isPdfLoading}
                disabled={isPdfLoading}
                label={
                  <div className="btn_label">
                    <Image src={MembershipDownload} />
                    <p>{t("downloadCardToPDF")}</p>
                  </div>
                }
              />
            )
          )}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    fmcVehicles: state.vehicles.vehicles.vehicles
  }
}

export default connect(mapStateToProps)(withTranslation("membershipFleetCard")(MembershipCard))
